module.exports = __webpack_public_path__ + "img/pgslot-newera.0bfc3211.png";